import { CommentOutlined } from '@ant-design/icons';

import ChannelPage from '../pages/ChannelPage';

import { SiteMap } from './index';

export const channelRoutes: SiteMap = {
  channel: {
    title: '채널 알림',
    page: ChannelPage,
    icon: <CommentOutlined />,
    key: '/channel',
    role: ['admin'],
    children: [
      {
        label: '매장 채팅',
        icon: null,
        key: '/channel/chat',
      },
      {
        label: '채널 관리',
        icon: null,
        key: '/channel/list',
      },
      {
        label: '전체 메시지 발송',
        icon: null,
        key: '/channel/compose',
      },
      {
        label: '공지 메시지 내역',
        icon: null,
        key: '/channel/messages',
      },
      {
        label: '채팅 메시지 내역',
        icon: null,
        key: '/channel/chat-messages',
      },
      {
        label: '카테고리 설정',
        icon: null,
        key: '/channel/category-config',
      },
    ],
  },
};
